// History Back for Android and post-action returns; headers use hierarchical BackButton instead.
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { parentPath, safeReturnTo } from '@/lib/appNavigation';
export function usePageBack(fallback?: string) {
  const navigate = useNavigate(); const location = useLocation();
  return useCallback(() => {
    const state = location.state as { returnTo?: unknown; from?: unknown } | null;
    const source = safeReturnTo(state?.returnTo) ?? safeReturnTo(state?.from) ?? safeReturnTo(new URLSearchParams(location.search).get('returnTo'));
    if (typeof window.history.state?.idx === 'number' && window.history.state.idx > 0) { navigate(-1); return; }
    const target = source && source !== `${location.pathname}${location.search}` ? source : safeReturnTo(fallback) ?? parentPath(location.pathname);
    navigate(target, { replace: true });
  }, [fallback, location, navigate]);
}
